module.exports = __webpack_public_path__ + "fonts/NotoSansCJKkr-DemiLight.069d05fd.woff";